import { Field } from "react-final-form";
import { MarkdownInput } from "@/shared/components";
import FormHelperText from "@mui/material/FormHelperText";

interface MarkdownProps {
  name: string;
  type?: "text" | "number";
  helperText?: string;
  [key: string]: any;
}

export function Markdown(props: MarkdownProps) {
  return (
    <Field
      {...props}
      parse={(value: any) => {
        if (value) {
          return props.type === "number" ? Number(value) : value;
        }
        return value;
      }}
      render={({ input: { onChange, value }, helperText }: any) => (
        <>
          <MarkdownInput value={value || ""} onChange={onChange} />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </>
      )}
    />
  );
}
